import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxQuestionAnswer/";

// 答疑解惑 - 列表
export const askMyPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myPage", {
           data: _params,
           method: "GET",
         });
       };

// 答疑解惑 - 添加
export const askAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/ask.js